
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { StringsMixin } from '@/mixins'

@Component({
	components: {
    },
})
export default class TooltipChip extends Mixins(StringsMixin) {
    @Prop({default: "top"}) pos: string = "top";
    @Prop({default: "primary"}) color: string;
    @Prop() textColor: string;
    @Prop() tooltipColor: string;
    @Prop() waitColor: string;
    @Prop({default: "Eat your vegetables"}) tooltip: string;
    @Prop() disabledTooltip: string;
    @Prop() text: string;
    @Prop({type: Boolean}) disabled;
    @Prop({type: Boolean}) large;
    @Prop({type: Boolean}) small;
    @Prop({type: Boolean}) xLarge;
    @Prop({type: Boolean}) dense;
    @Prop({type: Boolean}) loading;
    @Prop({type: Boolean}) largeText;

    get TooltipColor(): string{
      if( this.IsNotEmpty(this.tooltipColor) ) return this.tooltipColor;
      return this.color;
    }
    get WaitColor(): string {
      if( this.IsNotEmpty(this.waitColor) ) return this.waitColor;
      if( this.IsNotEmpty(this.text) ) return "white";
      return this.color;
    }

    get HasText() {
      return this.IsNotEmpty(this.text);
    }
    get TextStyle() {
      let style = this.dense? "mx-0 px-0" : "mx-4";
      if( this.IsNotEmpty(this.textColor) ) style += ` ${this.textColor}`;
      if( this.largeText ) style += ` text-h4`;
      return style;
    }
    get Tooltip(): string {
      if( this.disabled ) return this.disabledTooltip;
      return this.tooltip;
    }

    async onClick() {
      if( this.disabled ) return;
      this.$emit('click');
    }
    async onClickStop() {
      if( this.disabled ) return;
      this.$emit('click.stop')
    }
}
